exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wfh-loader-page[data-v-8cd452a0]{width:100%;display:flex;justify-content:center;align-items:center;height:200px}", ""]);

// exports
